var e = {
  height: {
    value: "{space.relative.full.value}"
  }
};
export { e as dialcodeselect };